import type { MapState, LabelToggles } from './mapState';

/**
 * Wire-format helpers for /api/v1/users/me/map-preferences.
 *
 * Backend uses snake_case JSON keys (per founder I3 default).
 * Frontend MapState uses camelCase. These helpers are the single
 * source of truth for the mapping — extending MapState without
 * updating both sides would otherwise silently drop fields.
 */

export interface MapPrefsWire {
  __v?: 1;
  basemap?: MapState['basemap'];
  contour_mode?: MapState['contourMode'];
  crop_fill_on?: boolean;
  cloud_mask_on?: boolean;
  rgb_scene_on?: boolean;
  labels?: LabelToggles;
  active_raster_mode?: MapState['activeRasterMode'];
  selected_date?: string | null;
  focused_crop_id?: string | null;
}

export function toWire(snapshot: MapState): MapPrefsWire {
  return {
    basemap: snapshot.basemap,
    contour_mode: snapshot.contourMode,
    crop_fill_on: snapshot.cropFillOn,
    cloud_mask_on: snapshot.cloudMaskOn,
    rgb_scene_on: snapshot.rgbSceneOn,
    labels: snapshot.labels,
    active_raster_mode: snapshot.activeRasterMode,
    selected_date: snapshot.selectedDate,
    focused_crop_id: snapshot.focusedCropId,
  };
}

export function fromWire(body: MapPrefsWire): Partial<MapState> {
  return {
    ...(body.basemap !== undefined ? { basemap: body.basemap } : {}),
    ...(body.contour_mode !== undefined ? { contourMode: body.contour_mode } : {}),
    ...(body.crop_fill_on !== undefined ? { cropFillOn: body.crop_fill_on } : {}),
    ...(body.cloud_mask_on !== undefined ? { cloudMaskOn: body.cloud_mask_on } : {}),
    ...(body.rgb_scene_on !== undefined ? { rgbSceneOn: body.rgb_scene_on } : {}),
    ...(body.labels !== undefined ? { labels: body.labels } : {}),
    ...(body.active_raster_mode !== undefined ? { activeRasterMode: body.active_raster_mode } : {}),
    ...(body.selected_date !== undefined ? { selectedDate: body.selected_date } : {}),
    ...(body.focused_crop_id !== undefined ? { focusedCropId: body.focused_crop_id } : {}),
  };
}
